enum CollectionsRoutes {
  Collections = 'collections',
  Check = 'collections/check-zip',
}

export default CollectionsRoutes;
